import request from './axios';
import { BreakdownInfo, QueryBreakdownParams, CreateBreakdownParams, UpdateBreakdownParams } from '../pages/Home/types';
import { SceneInfo, QuerySceneParams, CreateSceneParams, UpdateSceneParams, BatchDeleteSceneResponse } from '../types/scene.types';

export type { BreakdownInfo, QueryBreakdownParams, CreateBreakdownParams, UpdateBreakdownParams };

/** 获取分场列表 */
export const getBreakdownList = (params?: QueryBreakdownParams) => {
  return request.get<BreakdownInfo[]>('/api/breakdown', { params });
};

export const getBreakdownListByOrgId = (orgId: string) => {
  return request.get<BreakdownInfo[]>(`/api/breakdown/org/${orgId}`);
};

export const getBreakdownById = (breakdownId: string) => {
  return request.get<BreakdownInfo>(`/api/breakdown/${breakdownId}`, { timeout: 30000 });
};

export const getBreakdownListByName = (name: string) => {
  return request.get<BreakdownInfo[]>(`/api/breakdown/name/${name}`);
};

export const getBreakdownListByFilmId = (filmId: string) => {
  return request.get<BreakdownInfo[]>(`/api/breakdown/film/${filmId}`, { timeout: 30000 });
};

export const createBreakdown = (data: CreateBreakdownParams) => {
  return request.post<BreakdownInfo>('/api/breakdown', data);
};

export const updateBreakdown = (breakdownId: string, data: UpdateBreakdownParams) => {
  return request.patch<BreakdownInfo>(`/api/breakdown/${breakdownId}`, data);
};

export const deleteBreakdown = (breakdownId: string) => {
  return request.delete(`/api/breakdown/${breakdownId}`);
};

export const copyBreakdown = (data: {
  sourceBreakdownID: string;
  targetBreakdownName: string;
  targetBreakdownOwnerID?: string;
  targetBreakdownAssigneeID?: string;
  targetBreakdownOrgID?: string;
}) => {
  return request.post<BreakdownInfo>('/api/breakdown/copy', data, { timeout: 120000 });
};

export interface BreakdownCopyJob {
  jobID: string;
  sourceBreakdownID: string;
  targetBreakdownID: string | null;
  status: 'PENDING' | 'RUNNING' | 'SUCCEEDED' | 'FAILED';
  stage: string;
  completedItems: number;
  totalItems: number;
  progress: number;
  errorMessage: string | null;
}

export const createBreakdownCopyJob = (data: {
  clientRequestID?: string;
  sourceBreakdownID: string;
  targetBreakdownName: string;
  targetBreakdownOwnerID?: string;
  targetBreakdownAssigneeID?: string;
  targetBreakdownOrgID?: string;
}) => request.post<BreakdownCopyJob>('/api/breakdown/copy-jobs', data);

export const getBreakdownCopyJob = (jobID: string) =>
  request.get<BreakdownCopyJob>(`/api/breakdown/copy-jobs/${jobID}`);

// ==================== Scene（场次）相关接口 ====================

export const getSceneList = (params?: QuerySceneParams) => {
  return request.get<SceneInfo[]>('/api/scene', { params });
};

export const getScenesByBreakdownId = (breakdownId: string) => {
  return request.get<SceneInfo[]>(`/api/scene/breakdown/${breakdownId}`, { timeout: 30000 });
};

export const getSceneById = (sceneId: string) => {
  return request.get<SceneInfo>(`/api/scene/${sceneId}`);
};

export const createScene = (data: CreateSceneParams) => {
  return request.post<SceneInfo>('/api/scene', data);
};

export const createSceneBatch = (data: { scenes: CreateSceneParams[] }) => {
  return request.post<SceneInfo[]>('/api/scene/batch', data);
};

export const updateScene = (sceneId: string, data: UpdateSceneParams) => {
  return request.patch<SceneInfo>(`/api/scene/${sceneId}`, data);
};

export const updateScenesBatch = (scenes: { sceneID: string; [key: string]: any }[]) => {
  return request.patch<SceneInfo[]>('/api/scene/batch', { scenes });
};

export const deleteScene = (sceneId: string) => {
  return request.delete(`/api/scene/${sceneId}`);
};

export const deleteBreakdownBatch = (sceneIds: string[]) => {
  return request.post<BatchDeleteSceneResponse>('/api/scene/batch-delete', sceneIds, {
    timeout: 30000,
  });
};
